<template>
  <!-- 抽奖规则 -->
  <div class="prizeRule">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['抽奖规则',$route.meta.title]">
    </crumbs-bar>
    <!-- 表单容器 -->
    <el-scrollbar style="width: 100%;height:calc(100% - 60px);padding-top:20px;box-sizing:border-box;">
      <el-form :model="formData" label-position="right"
        label-width="120px" :rules="formRule" ref="form">
        <div class="form-item-wrap">
          <el-form-item label="抽奖开始时间" prop="startTime">
            <el-date-picker
              v-model="formData.startTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:200px;"
              placeholder="抽奖开始时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="抽奖结束时间" prop="endTime">
            <el-date-picker
              v-model="formData.endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:200px;"
              placeholder="抽奖结束时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="userType">
            <el-checkbox-group v-model="formData.userType" style="width: 1000px">
              <el-checkbox
                v-for="item in userTypeList"
                :key="item.value"
                :label="item.value">
                {{item.label}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="满足条件" prop="conditions">
            <el-select v-model="formData.conditions" placeholder="满足条件" style="width:200px;">
              <!-- <el-option label="主动下发" value="ActiveIssue"></el-option>
              <el-option label="登录" value="Login"></el-option>
              <el-option label="单笔金额" value="SingleStroke"></el-option>
              <el-option label="累计金额" value="Accumulates"></el-option> -->
              <el-option label="下单送抽奖" value="SingleStroke"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="赠送类型" prop="giftType">
            <el-select v-model="formData.giftType" placeholder="赠送类型" style="width:200px;">
              <!-- <el-option label="主动下发" value="ActiveIssue"></el-option>
              <el-option label="登录" value="Login"></el-option>
              <el-option label="超出" value="Surpass"></el-option>
              <el-option label="倍数" value="Multiples"></el-option> -->
              <el-option label="超出" value="Surpass"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="满足金额" prop="price">
            <el-input-number v-model="formData.price" style="width: 200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="最大参与次数" prop="num">
            <el-input-number v-model="formData.num" style="width: 200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="抽奖内容" prop="prizeList">
            <div class="prizeList">
              <div v-for="index in 4" :key="index - 1" class="prizeItem">
                <img-view :imgList="[{url: formData.prizeList[index - 1].img || '',id:0}]" :isMargin="false"></img-view>
                <el-tooltip class="item" effect="dark" :content="formData.prizeList[index - 1].name" placement="top">
                  <span class="prizeName">{{formData.prizeList[index - 1].name}}</span>
                </el-tooltip>
                <el-form label-position="right" label-width="40px" style="width: 90%;">
                  <el-form-item label="数量" style="margin: 0;">
                    <el-input-number v-model="formData.prizeList[index - 1].num" style="width: 50%;" 
                      :min="1" :controls="false"></el-input-number>
                    <el-button type="primary" plain style="margin-left: 5px;" @click="setPrizeData(index - 1)">选择</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="prizeItem">开始抽奖</div>
              <div v-for="index in 4" :key="index + 4" class="prizeItem">
                <img-view :imgList="[{url: formData.prizeList[index + 3].img || '',id:0}]" :isMargin="false"></img-view>
                <el-tooltip class="item" effect="dark" :content="formData.prizeList[index + 3].name" placement="top">
                  <span class="prizeName">{{formData.prizeList[index + 3].name}}</span>
                </el-tooltip>
                <el-form label-position="right" label-width="40px" style="width: 90%;">
                  <el-form-item label="数量" style="margin: 0;">
                    <el-input-number v-model="formData.prizeList[index + 3].num" style="width: 50%;" 
                      :min="1" :controls="false"></el-input-number>
                    <el-button type="primary" plain style="margin-left: 5px;" @click="setPrizeData(index + 3)">选择</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="抽奖描述" prop="desList">
            <el-table
              :data="formData.desList"
              tooltip-effect="dark"
              style="width: 1000px;border: 1px solid #EBEEF5;border-bottom: none;">
              <el-table-column
                label="序号"
                align="center"
                width="50">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                show-overflow-tooltip
                label="内容">
                <template slot-scope="scope">
                  <el-input v-if="scope.$index == 0" v-model="formData.desData.content" style="width:90%;"></el-input>
                  <span v-else>{{scope.row.content}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                width="160">
                <template slot-scope="scope">
                  <el-button type="primary" style="padding:2px 3px;" plain @click="addDes" v-if="scope.$index == 0">确定</el-button>
                  <el-button type="danger" style="padding:2px 3px;" plain @click="delDes(scope.$index)" v-else>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submit">保存</el-button>
            <el-button type="success" @click="changeStatus(1)">上架</el-button>
            <el-button type="warning" @click="changeStatus(2)">下架</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
    
    <!-- 数据选择 -->
    <tableDialog 
      v-if="dialogVisible"
      :title="'经营范围'"
      :isMoreSel="false"
      :searchValue="searchForm.name"
      :tableData="tableList"
      :tableHead="tableDataHead"
      :currPage.sync="currPage"
      :allPage="allPage"
      :pageSize="pageSize"
      :imgHead="imgHead"
      @search="getTableData"
      @rowClick="rowClick"
      @hanCurrChange="hanCurrChange"
      @close="dialogVisible = false"
    ></tableDialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";
export default {
  name: 'prizeRule',
  data() {
    return {
      id: '',
      // 表单数据
      formData: {
        startTime: '', // 抽奖开始时间
        endTime: '', // 抽奖结束时间
        userType: [], // 客户类型
        conditions: 'SingleStroke', // 满足条件
        giftType: 'Surpass', // 满足条件
        price: 100, // 满足金额
        num: 1, // 参与次数
        prizeList: [{},{},{},{},{},{},{},{}], // 抽奖内容
        desData: {
          content: '', // 内容
        }, // 抽奖描述
        desList: [{
          content: '', // 内容
        }], // 抽奖描述列表
      },
      formRule: {
        startTime: [mustFill],
        endTime: [mustFill],
        userType: [mustFill],
        conditions: [mustFill],
        giftType: [mustFill],
        price: [mustFill],
        num: [mustFill],
        prizeList: [mustFill],
      },
      // 选择奖品弹框相关
      dialogVisible: false,
      currPage: 1,
      allPage: 0,
      pageSize: 4,
      searchForm: {
        name: ''
      },
      tableList: [],
      tableDataHead: {},
      imgHead: {},
      // 用户类型列表
      userTypeList: []
    }
  },
  mounted() {
    this.getData()
    this.getUserType()
  },
  methods:{
    // 获取奖品列表
    getData(){
      this.$request({
        method: 'get',
        url: "Prize/GetPrizeList?keyword=&pageSize=1000&pageIndex=1&entId=" + window.localStorage.getItem('entId'),
      }).then(res => {
        if(res.Code == 0){
          this.getPrizeData(res.Source)
        }
      }).catch((err) => {
        window.console.log(err);
      })
    },
    // 获取中奖记录
    getPrizeData(data){
      this.$request({
        method: 'get',
        url: "LuckyDraw/GetLuckyDraw?entId=" + window.localStorage.getItem('entId'),
      }).then(res => {
        if(res.Code == 0){
          let list = [{},{},{},{},{},{},{},{}]
          list = list.map((item, index) => ({ id: res.Source['Prize' + (index + 1)],num: res.Source['PrizeCount' + (index + 1)] }))
          this.formData.prizeList = list.map(item => {
            for(let i = 0; i < data.length; i++){
              if(data[i].BH == item.id){
                return { id: item.id, name: data[i].PrizeName, img: data[i].ImgUrl, num: item.num }
              }
            }
            return {}
          })

          this.id = res.Source.ID
          this.formData.startTime = res.Source.ExpirationStartTime
          this.formData.endTime = res.Source.ExpirationTime
          this.formData.userType = this.$changeStrArr(res.Source.customertype)
          this.formData.conditions = res.Source.Conditions
          this.formData.giftType = res.Source.Kind
          this.formData.price = res.Source.Money
          this.formData.num = res.Source.Frequency
          this.formData.desList = [{ content: '' }].concat(this.$changeStrArr(res.Source.Information,'&&').map(item => ({ content: item })))
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },
    // 获取会员类型
    getUserType(){
      let data = {
        type: "CustomType"
      }
      let proc = "Proc_Admin_CustomerList" // 存储过程名
      let type = "ReturnList"
      this.$requestSys({
        method:"post",
        url: "coupon/ashx/returnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then((res) => {
        if (res.flag == 0) {
          this.userTypeList = res.data.map(item => {
            return {
              label: item.clienttype,
              value: item.TypeID
            }
          })
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    handleRefresh(){
      this.getData()
    },
    setPrizeData(index){
      this.prizeIndex = index
      this.getTableData()
    },
    // 获取弹出框表格数据
    getTableData(val,isRep){
      this.searchForm.name = isRep ? val : this.searchForm.name
      this.$request({
        method: 'get',
        url: "Prize/GetPrizeList?keyword=" + this.searchForm.name + "&pageSize=" + this.pageSize + "&pageIndex=" + this.currPage + '&entId=' + window.localStorage.getItem('entId'),
      }).then(res => {
        if (res.Code == 0) {
          this.tableList = res.Source
          this.tableDataHead = {BH: '编号',PrizeName: '名称',PrizeType: '类型',PrizeCount: '价值/优惠券编号'}
          this.imgHead = {ImgUrl: '图片'}
          this.allPage = res.TotalCount
          this.dialogVisible = true
        }else{
          this.$message({
            message: res.Message,
            type: 'error'
          })
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val;
      this.getTableData()
    },
    // 选择单条数据
    rowClick(row){
      this.formData.prizeList[this.prizeIndex] = {id: row.BH,name: row.PrizeName,img: row.ImgUrl,num: 1}
      this.dialogVisible = false
    },
    // 增加描述
    addDes(){
      this.formData.desList.push({
        content: this.formData.desData.content
      })
      this.formData.desData = {content: ''}
    },
    // 删除描述
    delDes(index){
      this.formData.desList.splice(index,1)
    },
    // 状态改变
    changeStatus(status){
      let msg = '确定要执行操作吗?'
      let type = 'info'
      let url = 'LuckyDraw/CreateDraw'
      if(status == 1){
        msg = '确定上架吗?'
        type = 'success'
        url = 'LuckyDraw/CreateDraw'
      } else if(status == 2){
        msg = '确定下架吗?'
        type = 'warning'
        url = 'LuckyDraw/BackOut'
      }
      this.$confirm(msg, '提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type
      }).then(() => {
        this.$request({
          url: url,
          method: "post",
          data: {
            entId: window.localStorage.getItem('entId')
          }
        }).then((res) => {
          if(res.Code == 0){
            this.$message({
              message: '操作成功',
              type: 'success'
            });
          }else{
            this.$message({
              message: res.Message,
              type: 'error'
            });
          }
        }).catch((err) => {
          window.console.log(err);
        });
      }).catch(() => {});
    },
    /**提交表单 */
    submit(){
      this.$refs['form'].validate((valid)=>{
        if (valid) {
          let list = this.formData.desList.slice(1)
          let data = {
            ID: this.id,
            entId: window.localStorage.getItem('entId'),
            ExpirationStartTime: this.formData.startTime,
            ExpirationTime: this.formData.endTime,
            LotteryName: '抽奖活动',
            Information: list.map(item => item.content).join('&&'),
            customertype: this.formData.userType.join(','), // 客户类型
            qykzlx: 0,
            ExcludeType: 0,
            LimitType: 0,
            Conditions: this.formData.conditions,
            Kind: this.formData.giftType,
            Money: this.formData.price,
            Frequency: this.formData.num,
          }
          this.formData.prizeList.forEach((item,index) => {
            data['Prize' + (index + 1)] = item.id
            data['PrizeCount' + (index + 1)] = item.num
          })
          this.$request({
            method: "post",
            url: "LuckyDraw/UpdateLuckDraw",
            data: data
          }).then((res) => {
            if(res.Code == 0){
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.getData()
            }else{
              this.$message({
                message: res.Message,
                type: 'error'
              });
            }
          }).catch((err) => {
            window.console.log(err)
          });
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.prizeRule{
  width: 100%;
  height: 100%;
}
.prizeList{
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-content: space-between;
  flex-wrap: wrap;
  width: 600px;
  height: 600px;
  padding: 10px;
  border: 1px solid #000;
  border-radius: 10px;
}
.prizeItem{
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  width: 32%;
  height: 32%;
  border: 1px solid #000;
  border-radius: 10px;
}
.prizeName{
  box-sizing: border-box;
  display: block;
  width: 80%;
  height: 30px;
  margin: 0 auto;
  padding: 0 10px;
  line-height: 30px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
